import {combineReducers} from "redux";
import {carsReducer} from "./carsReducer";
import {appReducer} from "./appReducer";
import {clientReducer} from "./clientReducer";
import {ordersReducer} from "./ordersReducer";
import { analyticsReducer } from "./analyticsReducer";
import {telegramClientsReducer} from "./telegramClientReducer";

export const rootReducer = combineReducers({
    app: appReducer,
    cars: carsReducer,
    orders: ordersReducer,
    clients: clientReducer,
    analytics: analyticsReducer,
    telegramClients: telegramClientsReducer
})